import styled, { keyframes } from "styled-components";

import designSystemColors from "../../styles";
import { TDSButton } from "./types";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const Button = styled.button<
  TDSButton & React.ButtonHTMLAttributes<HTMLButtonElement>
>`
  border-radius: 4px;
  text-align: center;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  transition: 0.2s;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;

  ${({ buttonType }) =>
    buttonType === "primary" &&
    `
      background-color: ${designSystemColors.generalButtons};
      border: none;
      color: ${designSystemColors.textGeneralButtons};

    `}

  ${({ buttonType }) =>
    buttonType === "secondary" &&
    `
        background-color: ${designSystemColors.secondaryButtons};
        border: none;
        color: ${designSystemColors.textGeneralButtons};
      `}

    ${({ buttonType, isCancelType }) =>
    buttonType === "primary" &&
    isCancelType &&
    `     background-color: ${designSystemColors.background};
          border: 1px solid ${designSystemColors.generalButtons};
          color: ${designSystemColors.generalButtons};
          `}

  ${({ buttonType, isCancelType }) =>
    buttonType === "secondary" &&
    isCancelType &&
    `     background-color: ${designSystemColors.background};
  border: 1px solid ${designSystemColors.secondaryButtons};
  color: ${designSystemColors.secondaryButtons};
                    `}

  /* Estilo para o botão desabilitado */
  ${({ isDisabled, buttonType }) =>
    isDisabled &&
    buttonType === "primary" &&
    `
      cursor: not-allowed;
      opacity: 0.3;
      background-color: ${designSystemColors.generalButtons};
      color: ${designSystemColors.textGeneralButtons};
    `}

  ${({ isDisabled, buttonType }) =>
    isDisabled &&
    buttonType === "secondary" &&
    `
      cursor: not-allowed;
      opacity: 0.3;
      background-color: ${designSystemColors.secondaryButtons};
      color: ${designSystemColors.textGeneralButtons};
      border: "none";
    `}
    &:hover {
    opacity: ${({ opacityOnHover }) => opacityOnHover ?? "0.8"};
  }
`;

export const Loader = styled.div<{ buttonType: "primary" | "secondary" }>`
  border: 4px solid ${designSystemColors.background};
  border-top: 4px solid
    ${({ buttonType }) =>
      buttonType === "primary"
        ? designSystemColors.generalButtons
        : designSystemColors.secondaryButtons};
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: ${spin} 1.5s linear infinite;
`;
